import React, { Component, Fragment } from "react";
import PCBQtyValueRowReorderComponent from "./PCBQtyValueReorder/PCBQtyValueRowReorderComponent";
import "../ReorderComponent/ReorderComponent.css";

const qtyValueRowsReorder = [
    [5,10,15,20,25],
    [30,50,75,100,125],
    [150,200,250,300,400],
    [450,500,600,700,800],
    [900,1000],
    // [900,1000,1500,2000,2500],
    // [3000,3500,4000,4500,5000],
    // [5500,6000,6500,7000,7500],
    // [8000,8500,9000,9500,10000],
    // [11000,12000,13000,14000,15000],
    // [16000,17000,18000,19000,25000],
    // [30000,40000,50000,60000,70000],
    // [80000],

];

const OrderType1ReorderComponent = (props) => {

    return(
        <span>
            <span><small>PCB再注文数量</small></span><br/>
             <label className="dropdown qty-label">

                            <div className="dd-button">
                                <div className="pull-left">{props.reorderParams.reorderPcbQty}</div>
                                <div className="pull-right text-small down-arrow">&nbsp;&#9660;</div>

                            </div>

                            <input type="checkbox" className="dd-input" id="test"/>
                                <ul className="dd-menu">
                                    {qtyValueRowsReorder.map((value => {
                                        return(
                                            <li>
                                                <PCBQtyValueRowReorderComponent
                                                    row = {value}
                                                    selectedQty = {props.reorderParams.reorderPcbQty}
                                                    setReorderQty = {props.setReorderQty}
                                                />
                                            </li>)
                                    }))}
                                </ul>

                        </label>
        </span>
    );
};

const OrderType3ReorderComponent = (props) => {
    return(
        <span>

            <span><small>メタルマスク再注文数量</small></span><br/>
            <span>
                <input value={props.reorderParams.reorderSmtQty} onChange={props.setSMTReorderQty} min="1" type="text"
                       className="form-control input-sm input-stencil-qty-reorder"
                       name="smtQty"/>
            </span>
        </span>
    );
};

class  ReorderComponent extends Component {
    constructor(props){
        super(props);
        this.state = {
            reorderParams : {}
        };
        this.setReorderQty = this.setReorderQty.bind(this);
        this.setSMTReorderQty = this.setSMTReorderQty.bind(this);
    }


    setReorderQty = (qty, type) => {
        this.props.setReorderItems(this.props.orderItem.orderUUID, qty, "pcb");
    };

    setSMTReorderQty = (event, type) => {
        this.props.setReorderItems(this.props.orderItem.orderUUID, parseInt(event.target.value), "smt");
    };

    render(){
        // console.log("REORDER PARAMS ====> ", this.state.reorderParams);
        return(
            <Fragment>
                {this.props.orderType === 1 ?
                    <OrderType1ReorderComponent orderItem = {this.props.orderItem}
                                                setReorderQty = {this.setReorderQty}
                                                reorderParams = {this.props.reorderParams[this.props.orderItem.orderUUID]}/>

                    : this.props.orderType === 2 ?
                        <span>
                            <OrderType1ReorderComponent orderItem = {this.props.orderItem}
                                                        setReorderQty = {this.setReorderQty}
                                                        reorderParams = {this.props.reorderParams[this.props.orderItem.orderUUID]}/><br/>

                            <OrderType3ReorderComponent orderItem = {this.props.orderItem}
                                                        setSMTReorderQty = {this.setSMTReorderQty}
                                                        reorderParams = {this.props.reorderParams[this.props.orderItem.orderUUID]}/>
                        </span>
                        : this.props.orderType === 3 ?
                            <OrderType3ReorderComponent orderItem = {this.props.orderItem}
                                                        setSMTReorderQty ={this.setSMTReorderQty}
                                                        reorderParams = {this.props.reorderParams[this.props.orderItem.orderUUID]}/> : ""


                }
            </Fragment>
        );
    }

}

export default ReorderComponent;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/OrderItem/ReorderComponent/ReorderComponent.js